import loadable from '@loadable/component';

const MenuLinkNative =
  RUNTIME_ENV === 'native'
    ? loadable(() => import('./MenuLinkNative'))
    : () => null;

export { MenuLinkNative };
